import React, { useEffect } from 'react';
import AgentRow from './AgentRow';
import NoData from 'component/molecules/Table/TableComponents/NoData/NoData';

const APIRecords = ({
  selectAllTrigger,
  formik,
  selectedIds,
  setSelectedIds,
  agentData,
  isPending,
  testStatuses,
  setTestStatuses,
  manualClear,
  refetchAgentData,
  bulkTaskMap,
  bulkRunNonce,
  suppressRefetch,
  onRowSyncComplete,
  setIsSyncingAll,
  isAgentConnected,
}) => {
  useEffect(() => {
    if (manualClear || !selectAllTrigger) return;
    const currentData = agentData?.data || [];
    const allIds = currentData.map((item) => item.id);
    setSelectedIds(allIds);
  }, [selectAllTrigger, manualClear]);

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <>
      {0 === agentData?.data.length && <NoData minHeight={450} />}
      {agentData?.data?.map((record, index) => (
        <AgentRow
          key={`${record.id}-${record.details?.pullFrequency || 0}`}
          record={record}
          index={index}
          isSelected={selectedIds.includes(record.id)}
          formik={formik}
          onToggleSelect={toggleSelect}
          onForceSync={(record) => console.log('Force sync:', record)}
          testStatus={
            testStatuses[record?.id] ??
            (Number(record?.details?.detail?.connectionStatus) === 3
              ? 'Healthy'
              : Number(record?.details?.detail?.connectionStatus) === 2
              ? 'Failed'
              : 'Untested')
          }
          APIRecords
          // setTestStatus={(status) =>
          //   setTestStatuses((prev) => ({ ...prev, [record.id]: status }))
          // }
          setTestStatuses={setTestStatuses}
          refetchAgentData={refetchAgentData}
          assignedTaskId={bulkTaskMap?.[record?.details?.detail?.id]}
          bulkRunNonce={bulkRunNonce}
          suppressRefetch={suppressRefetch}
          onSyncComplete={onRowSyncComplete}
          setIsSyncingAll={setIsSyncingAll}
          isAgentConnected={isAgentConnected}
        />
      ))}
    </>
  );
};

export default APIRecords;
